<h3 class="mb-4">
  @if (icon) {
    <i class="pi {{ icon }} mr-3 text-3xl"></i>
  }
  {{ label | translate }}
</h3>
